import axios from "axios";

// const instance = axios.create({ baseURL: "http://localhost:4000/" });
const instance = axios.create({ baseURL: "https://api.totalhomecrm.com/" });
// const instance = axios.create({ baseURL: "https://total-home-app-backend.herokuapp.com/" });
// const instance = axios.create({ baseURL: "https://totalhomeapp.ap-south-1.elasticbeanstalk.com/" });
// const instance = axios.create({ baseURL: "https://totalhome-backend.vercel.app/" });

export default instance;